import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import { get } from "../../helpers/utils"
import * as styles from "./TabsContainer-tw-styles"
import TextContent from "../TextContent/TextContent"
import useScreenSize from "../../hooks/useScreenSize"

const TabsContainer = props => {
  const {
    tabbingWrapperCollection,
    variant,
    title,
    brandTabs = false,
  } = { ...props }
  const tabsList = get(tabbingWrapperCollection, "items", [])
  const [activeTab, setActiveTab] = useState(0)
  const [item, setItem] = useState(tabsList[0]?.textContentCollection)
  const screen = useScreenSize()

  useEffect(() => {
    const param =
      typeof window !== "undefined" ? window?.location?.hash : undefined
    if (param) {
      const tab = tabsList?.findIndex(
        item => `#${item?.internalTitle}` === param
      )
      if (tab) {
        setActiveTab(tab)
      }
    }
  }, [])

  const checkActive = (index, className) =>
    activeTab === index ? className : ""
  const style = styles[variant] || styles.defaultStyle

  const filterCategory = (items, index) => {
    const filteredData = tabsList?.filter(value => {
      return value.title === items
    })

    setItem(filteredData.length > 0 && filteredData[0]?.textContentCollection)
    setActiveTab(index)
  }

  const getNewTabs = () => {
    if (brandTabs) {
      return (
        <div className={style?.galleryContainerWrapper}>
          <div className={style?.tabs}>
            <div className="">
              {tabsList?.map((items, index) => (
                <>
                  <div
                    className={`${style?.filterTab} ${checkActive(
                      index,
                      style?.activeTab
                    )}`}
                    onClick={() => setActiveTab(index)}
                    key={index}
                    id="tabClick"
                  >
                    {" "}
                    {items?.title}
                  </div>
                  <div
                    className={
                      activeTab === index ? style?.show : style?.content
                    }
                  >
                    <div className={style?.imgWrapper}>
                      {items?.textContentCollection?.items?.map(
                        (value, idx) => (
                          <TextContent
                            shortDescription={value.shortDescription}
                            variant={variant}
                            key={idx}
                            className={style?.imgWrapperDescription}
                          />
                        )
                      )}
                    </div>
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>
      )
    }
  }
  return (
    <>
      {screen?.isMobile && brandTabs ? (
        getNewTabs()
      ) : (
        <div className={style?.galleryContainer}>
          <div className={style?.tabHeading}>
            <h2 className={style?.galleryHeading}>{title}</h2>
          </div>
          <div className={style?.galleryContainerWrapper}>
            <div className={style?.tabs}>
              <ul className={style?.filterTabs}>
                {tabsList?.map((items, index) => (
                  <li
                    className={`${style?.filterTab} ${checkActive(
                      index,
                      style?.activeTab
                    )}`}
                    onClick={() => filterCategory(items?.title, index)}
                    key={index}
                    id="tabClick"
                  >
                    {" "}
                    {items?.title}
                  </li>
                ))}
              </ul>
            </div>
            <div className={style?.panels}>
              <div className={style?.imgWrapper}>
                {item?.items?.map((value, idx) => (
                  <TextContent
                    shortDescription={value.shortDescription}
                    variant={variant}
                    key={idx}
                    className={style?.imgWrapperDescription}
                  />
                ))}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

TabsContainer.propTypes = {
  title: PropTypes.string,
  tabbingWrapperCollection: PropTypes.object,
  variant: PropTypes.string,
  brandTabs: PropTypes.bool,
}

export default TabsContainer
